<template>
  <div class="pathology-selector">
    <label class="field-label">Pathology</label>
    <select
      class="pathology-select"
      :value="selectedId"
      :disabled="disabled"
      @change="$emit('update:selectedId', $event.target.value)"
    >
      <option :value="null" disabled>Select a pathology to add...</option>
      <option v-for="p in pathologies" :key="p.id" :value="p.id">
        {{ p.label }}
      </option>
    </select>

    <div v-if="isOther" class="other-field">
      <label class="field-label">Pathology name</label>
      <input
        type="text"
        class="other-input"
        :value="otherName"
        :disabled="disabled"
        placeholder="Enter pathology name"
        @input="$emit('update:otherName', $event.target.value)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  pathologies: {
    type: Array,
    default: () => [],
  },
  selectedId: {
    type: [String, Number],
    default: null,
  },
  otherName: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["update:selectedId", "update:otherName"]);

const isOther = computed(() => {
  if (!props.selectedId) return false;
  const selected = props.pathologies.find((p) => p.id === props.selectedId);
  return (selected?.label || "").trim().toLowerCase() === "other";
});
</script>

<style scoped>
.pathology-selector {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.field-label {
  font-size: 0.72rem;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
}

.pathology-select,
.other-input {
  width: 100%;
  padding: 0.45rem 0.55rem;
  border-radius: var(--border-radius-small);
  border: 1px solid var(--color-border-primary);
  background-color: var(--color-bg-secondary);
  color: var(--color-text-primary);
  font-size: 0.85rem;
  font-family: inherit;
}

.pathology-select:focus,
.other-input:focus {
  outline: none;
  border-color: var(--color-accent-primary);
}

.pathology-select:disabled,
.other-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.other-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-top: 0.2rem;
}
</style>
